import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import dateFormat from '../../../utils/dateFormat';
import useStyles from './styles';

const campaignTypesTranslations = {
  'Form': 'ANALYTICS.CAMPAIGN_TYPES.FORM',
}

const Table = ({ data, headerNames }) => {
  const { t } = useTranslation(['translation']);
  const classes = useStyles();
  return (
    <div className={classes.tableClass}>
      {headerNames.map((name, i) => (
        <div key={i} className={classes.headerCell}>{name}</div>
      ))}
      {data.map(row => {
        const status = row.active && new Date() <= new Date(row.dateEnd)
          ? t('ANALYTICS.CAMPAIGN_STATUS.ACTIVE')
          : t('ANALYTICS.CAMPAIGN_STATUS.FINISHED');
        const campaignType = campaignTypesTranslations[row.type] || row.type;
        return (
          <React.Fragment key={row.id}>
            <div className={classes.cell}>{row.name}</div>
            <div className={classes.cell}>{t(campaignType)}</div>
            <div className={classes.cell}>{status}</div>
            <div className={classes.cell}>{t('COMMON.INTL_NUMBER', { value: row.KPIs })}</div>
            <div className={classes.cell}>{dateFormat(row.dateEnd)}</div>
          </React.Fragment>
        )
      })}
    </div>
  );
};


Table.propTypes = {
  data: PropTypes.array.isRequired,
};

export default Table;
